import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OrderService } from '../../Services/order.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-application-id',
    templateUrl: './application-id.component.html',
    styleUrls: ['./application-id.component.scss'],
    standalone: false
})
export class ApplicationIdComponent implements OnInit {
  showError = false
  errorMsg = ''
  modalRef?: BsModalRef;
  applicationForm: FormGroup;
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder, private orderService: OrderService,
    private router: Router) { }

  ngOnInit(): void {

    this.applicationForm = this.formBuilder.group({
      applicationId: ['', [Validators.required]]
    });
  }


  openModal(template: TemplateRef<any>) {
    this.showError = false
    setTimeout(() => {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'modal-dialog-centered' })
      );
    }, 0);
  }
  closeModal() {
    this.modalRef.hide()
  }

  closeError() {
    if (this.showError){
      this.showError =false
    }
  }

  createApplicationOrder() {
    this.showError = false
    let applicationId;
    applicationId = this.applicationForm.controls.applicationId.value
    var applicationIdString = applicationId;

    if (applicationIdString == '' || applicationIdString == null || applicationIdString.toString().length < 8 || applicationIdString.toString().length > 8){
      this.showError = true
      this.errorMsg = 'Invalid application id.'
    }
    else{
        this.orderService.copyApplicationOrder( {"application_id": applicationId})
        .subscribe(
          data => {
            if (data.status == 200) {
              this.modalRef.hide()
              this.router.navigate(['mycart'])
            }
            else if (data.status == 403){
              this.showError = true
              this.errorMsg = data.response
            }

          }
        );
    }


  }

}
